import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getNextTransferOrderNumberRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/transfer-orders/next-number',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/transfer-orders/next-number' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getNextTransferOrderNumberResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'THE NEXT ORDER NUMBER OBJECT',
        json: {
            "orderNumber": "10005"
        },
    },
};

const data: RequestDefinitionData = {
    id: 'get-next-transfer-order-number',
    title: 'Get the next transfer order number',
    description: 'Returns the next available transfer order number based on the system\'s auto-numbering settings. '
        + 'Note: calling this endpoint immediately consumes the order number — the number is incremented and '
        + 'reserved regardless of whether a transfer order is subsequently created. '
        + 'Returns a 400 error if transfer order auto-numbering is not enabled; in that case, enable it in the Module '
        + 'Options or supply the order number manually when creating a transfer order.',
    endpoint: {
        verb: 'GET',
        path: '/transfer-orders/next-number',
        tooltip: 'Get the next transfer order number',
    },
    attributes: [],
    requestObject: getNextTransferOrderNumberRequest,
    responseObject: getNextTransferOrderNumberResponse,
};

export default data;